import { NgModule } from '@angular/core';
import { ListaFiltriCompilabiliComponent } from './lista-filtri-compilabili.component';
import { FiltroCompilabile } from './filtro-compilabile/filtro-compilabile.component';
import { OpzioniFiltroCompilabile } from './filtro-compilabile/opzioni-filtro-compilabile/opzioni-filtro-compilabile.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ListaFiltriCompilabiliComponent,
        FiltroCompilabile,
        OpzioniFiltroCompilabile
    ],
    entryComponents: [
    ],
    providers: [
    ],
    exports: [
        ListaFiltriCompilabiliComponent,
        FiltroCompilabile,
        OpzioniFiltroCompilabile
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NzCheckboxModule,
        NzDatePickerModule,
        NzRadioModule,
        NzModalModule,
        NzInputModule,
        NzEmptyModule,
        NzSelectModule,
        TranslateModule
    ]
})
export class ListaFiltriCompilabiliModule { }